import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SelectField } from 'components/Inputs/Inputs'
import flight from 'assets/images/dashboard/Flight.svg'
import hotel from 'assets/images/dashboard/hotel.svg'
import transportation from 'assets/images/dashboard/Transportation.svg'
import box from 'assets/images/dashboard/hotel-1.svg'
import {
  useGetConfigurationQuery,
  useGetDynamicConfigurationQuery,
  usePostDynamicConfigurationMutation,
} from 'redux/store/actions'
import { Field, Form } from 'react-final-form'
import MyResponsiveBullet from './MyResponsiveBullet'

export default function HomeDash(): JSX.Element {
  const { t } = useTranslation()
  const onSubmit = (values: any) => {}
  const [numberOfDays, setNumberOfDays] = useState(90)
  const [numberOfDaysHotels, setNumberOfDaysHotels] = useState(90)

  const [postDynamicConfiguration] = usePostDynamicConfigurationMutation()
  const [dataElement, setDataElement]: any = useState()
  const [dataHotelElement, setDataHotelElement]: any = useState()
  const { data: numberOfBoking } = useGetDynamicConfigurationQuery({
    name: 'api/Dashboard/number-of-bookings',
  })
  const getDataFun = async () => {
    const result = await postDynamicConfiguration({
      url: `api/Dashboard/best-packages/?lastNumberOfDays=${numberOfDays}`,
    })
    setDataElement(result)
  }
  const getDataHotelFun = async () => {
    const result = await postDynamicConfiguration({
      url: `api/Dashboard/top-booked-hotels/?lastNumberOfDays=${numberOfDaysHotels}`,
    })
    setDataHotelElement(result)
  }
  useEffect(() => {
    getDataFun()
  }, [numberOfDays])
  useEffect(() => {
    getDataHotelFun()
  }, [numberOfDaysHotels])

  const timeOptions = [
    {
      Id: '90',
      Value: 'Three Month',
      ValueAr: 'ثلاثة أشهر',
    },
    {
      Id: '180',
      Value: 'Six Month',
      ValueAr: 'ستة أشهر',
    },
    {
      Id: '365',
      Value: 'Year',
      ValueAr: 'سنة',
    },
    {
      Id: '1095',
      Value: '3 Years',
      ValueAr: 'ثلاث سنوات',
    },
    {
      Id: '1825',
      Value: '5 Years',
      ValueAr: 'خمس سنوات',
    },
  ]

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{}}
      render={({ handleSubmit, form, submitting, pristine, modifiedSinceLastSubmit }) => (
        <form onSubmit={handleSubmit} className="mt-5">
          <div className="flex justify-between gap-4">
            <div className="h-[370px] rounded-2xl pb-20 bulletContainer w-[49%] bg-white p-4">
              <h2 className="font-black">{t('The Best Seller Packages')}</h2>
              <div className="w-1/2 mt-5 pl-0 p-1">
                <Field
                  label=""
                  name="packageTypeId1"
                  render={SelectField}
                  options={timeOptions}
                  valueField="Id"
                  textField="Value"
                  onChange={(e: any) => {
                    setNumberOfDays(e)
                  }}
                />
              </div>
              <div className="pb-7 h-full mt-5 ">
                <MyResponsiveBullet elemnts={dataElement?.data?.data || []} />
              </div>
            </div>
            <div className="h-[370px] rounded-2xl pb-20 bulletContainer w-[49%] bg-white p-4">
              <h2 className="font-black">{t('Most Booked Hotels')}</h2>
              <div className="w-1/2 mt-5 pl-0 p-1">
                <Field
                  label=""
                  name="packageTypeId"
                  render={SelectField}
                  options={timeOptions}
                  valueField="Id"
                  onChange={(e: any) => {
                    setNumberOfDaysHotels(e)
                  }}
                  textField="Value"
                />
              </div>
              <div className="pb-7 h-full mt-5 ">
                <MyResponsiveBullet elemnts={dataHotelElement?.data?.data || []} />
              </div>
            </div>
          </div>
          <div className="w-full flex justify-between gap-3 mt-4">
            <div className="w-1/4 p-1">
              <div className="flex bg-white rounded-2xl p-4 flex-col justify-center items-center">
                <img className="w-20 h-20 mb-3" src={hotel} alt="bed" />
                <h2 className="font-bold">{numberOfBoking?.items?.NumberOfHotelBookings}</h2>
                <h4>{t('Booking in Hotels')}</h4>
              </div>
            </div>
            <div className="w-1/4 p-1">
              <div className="flex bg-white rounded-2xl p-4 flex-col justify-center items-center">
                <img className="w-20 h-20 mb-3" src={flight} alt="bed" />
                <h2 className="font-bold">{numberOfBoking?.items?.NumberOfFlightBookings}</h2>
                <h4>{t('Booking in Flights')}</h4>
              </div>
            </div>
            <div className="w-1/4 p-1">
              <div className="flex bg-white rounded-2xl p-4 flex-col justify-center items-center">
                <img className="w-20 h-20 mb-3" src={transportation} alt="bed" />
                <h2 className="font-bold">
                  {numberOfBoking?.items?.NumberOfTransportationBookings}
                </h2>
                <h4>{t('Booking in Transportation')}</h4>
              </div>
            </div>
            <div className="w-1/4 p-1">
              <div className="flex bg-white rounded-2xl p-4 flex-col justify-center items-center">
                <img className="w-20 h-20 mb-3" src={box} alt="bed" />
                <h2 className="font-bold">{numberOfBoking?.items?.NumberOfPackageBookings}</h2>
                <h4>{t('Booking in Packages')}</h4>
              </div>
            </div>
          </div>
        </form>
      )}
    />
  )
}
